import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onClickButton"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Button } from 'foundations-components/transitional/components/Button';
import { actions } from '../../constants/actions';
import { jsx as _jsx } from "react/jsx-runtime";
const SendInvoiceButton = _ref => {
  let {
      onClickButton
    } = _ref,
    buttonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(Tooltip, {
    "data-test-id": "send-btn-tooltip",
    disabled: !buttonProps.disabled,
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "invoices.components.invoiceActionsDropdown.tooltips.pending.send"
    }),
    children: /*#__PURE__*/_jsx(Button, Object.assign({
      "data-test-id": "send-btn",
      use: "tertiary-light",
      responsive: false,
      size: "extra-small",
      onClick: () => {
        onClickButton(actions.SEND);
      }
    }, buttonProps, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "invoices.components.invoiceActionsDropdown.buttons.send"
      })
    }))
  }, "send-btn");
};
export default SendInvoiceButton;